import { isApiError } from '@/services/api';

/**
 * Human-readable message from a rejected api call. The shared Axios client rejects
 * with a normalized `ApiError` whose `message` already joins any Laravel validation
 * strings, so we surface that directly; falls back for non-api errors.
 */
export const apiErrorMessage = (err: unknown, fallback = 'Something went wrong'): string => {
    if (isApiError(err)) return err.message;
    if (err instanceof Error && err.message) return err.message;
    return fallback;
};
